import { ArticleListPage, ResourceArticle } from "@/components/resources/ArticleListPage";

const articles: ResourceArticle[] = [
  {
    id: "essai-gratuit",
    title: "Comment fonctionne l'essai gratuit de 14 jours ?",
    category: "Compte",
    readTime: "2 min",
    excerpt: "Inscription sans carte bancaire et accès au tableau de bord avec la création manuelle.",
    body: [
      "L'essai gratuit de 14 jours s'applique à la création manuelle. Inscrivez-vous, puis choisissez « Création manuelle » dans votre espace compte : aucune carte bancaire n'est demandée.",
      "La Boutique IA est une offre payante séparée : le paiement est demandé avant la génération de la boutique.",
    ],
  },
  {
    id: "mot-de-passe",
    title: "J'ai oublié mon mot de passe",
    category: "Compte",
    readTime: "1 min",
    excerpt: "Réinitialisez votre mot de passe en quelques clics.",
    body: [
      "Sur la page de connexion, cliquez sur « Mot de passe oublié ? » et saisissez votre adresse e-mail. Vous recevrez un lien pour choisir un nouveau mot de passe.",
    ],
  },
  {
    id: "commande-test",
    title: "Passer une commande test",
    category: "Paiements",
    readTime: "3 min",
    excerpt: "Vérifiez votre parcours d'achat avant d'ouvrir votre boutique.",
    body: [
      "Ajoutez un produit à votre panier depuis l'aperçu de votre boutique, puis suivez le paiement jusqu'au bout afin de vérifier les informations affichées à vos clients.",
    ],
  },
  {
    id: "domaine-verif",
    title: "Mon domaine n'est pas encore vérifié",
    category: "Domaines",
    readTime: "3 min",
    excerpt: "Délais de propagation DNS et vérifications à effectuer.",
    body: [
      "Après l'ajout des enregistrements DNS, la propagation peut prendre de quelques minutes à 48 heures. Vérifiez que les valeurs saisies correspondent exactement à celles indiquées dans Sokoby.",
    ],
  },
  {
    id: "supprimer-compte",
    title: "Supprimer mon compte et mes données",
    category: "Confidentialité",
    readTime: "2 min",
    excerpt: "Comment demander la suppression définitive de vos données.",
    body: [
      "Depuis la gestion du compte, vous pouvez vous déconnecter. Pour une suppression définitive de vos données, contactez notre support qui traitera votre demande.",
    ],
  },
];

export default function HelpCenter() {
  return (
    <ArticleListPage
      title="Centre d'aide"
      intro="Réponses aux questions les plus fréquentes sur votre compte, vos paiements et vos domaines."
      articles={articles}
      cta={{ label: "Vous ne trouvez pas votre réponse ? Contactez le support", to: "/support" }}
    />
  );
}
